import { Message } from '../types';
import ShareButton from './ShareButton';

interface MessageBubbleProps {
  message: Message;
  index: number;
  onShare?: () => Promise<void> | void;
  showShare?: boolean;
  highlightShare?: boolean;
  reactions?: Record<string, number>;
  onReact?: (emoji: string) => void;
}

const reactionEmojis = ['👍', '😂', '🤡'];

export default function MessageBubble({
  message,
  onShare,
  showShare,
  highlightShare,
  reactions,
  onReact,
}: MessageBubbleProps) {
  const isAssistant = message.role === 'assistant';

  return (
    <div className={`message ${isAssistant ? 'assistant' : 'user'}`}>
      <div className="bubble-header">
        <span className="bubble-role">
          {isAssistant ? 'BOTKOP' : 'ТИ'}
        </span>
        {showShare && onShare && (
          <ShareButton
            label="Share"
            compact
            onShare={onShare}
            highlight={highlightShare}
          />
        )}
      </div>
      <div className="message-content">{message.content}</div>
      {isAssistant && onReact && (
        <div className="reaction-bar">
          {reactionEmojis.map((emoji) => (
            <button
              key={emoji}
              className="reaction-btn"
              onClick={() => onReact(emoji)}
              type="button"
            >
              <span className="reaction-emoji">{emoji}</span>
              <span className="reaction-count">
                {reactions?.[emoji] ?? 0}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
